import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { EDIT_STORE } from "../apollo/mutations";
import { useEffect } from "react";
import closeModal from "../common/closeModal";

const useEditStore = (rowData) => {

  const defaultValues = {
    id: rowData?.id ?? 0,
    name: rowData?.name ?? "",
    is_active: rowData?.is_active ?? true,
    image: null
  };

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });

  const [submit] = useMutation(EDIT_STORE);

  useEffect(() => {
    reset(defaultValues);
  }, [rowData, reset]);

  const onEditStore = async (data) => {
    try {
      let payload = {
        variables: {
          input: {
            id: data.id,
            name: data.name,
            is_active: data.is_active,
          },
          image: data.image,
        },
      };

      await submit(payload);
      reset(defaultValues);
      closeModal("edit-units");

    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    reset(defaultValues);
    closeModal("edit-units");
  };

  return {
    values: {
      control,
      errors,
      image: watch("image"),
    },
    functions: {
      onSubmit: handleSubmit(onEditStore),
      onCancel,
    },
  };
};

export default useEditStore;
